export const isLastItemOdd = (index: number, totalItems: number) => {
  const isIndexEven = index % 2 === 0;
  const isLastItem = index + 1 === totalItems;
  return isIndexEven && isLastItem;
};
